export default {
  agent: 'Agent',
  login: 'Connexion',
  logout: 'Déconnexion',
  pause: 'Pause',
  resume: 'Reprendre',
};
